<template>
  <div>
    <dropdown class="actions" :actions="actions" @action="action"></dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dropdown from '@kevindesousa/vue-dropdown'

export default {
  name: 'customer-dropdown',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  components: { dropdown },

  data () {
    return {
      actions: [{
        title: 'Details',
        action: 'details'
      }, {
        title: 'Delete',
        action: 'delete'
      }]
    }
  },

  computed: {
    ...mapGetters('customers', {
      getById: 'getById'
    }),

    customer () {
      return this.getById(this.id)
    }
  },
  methods: {
    ...mapActions('customers', ['removeCustomer']),

    action (action) {
      switch (action) {
      case 'details':
        this.$router.push({name: 'customer', params: {id: this.id}})
        break
      case 'delete':
        this.removeCustomer({customer: this.customer})
        this.$notify({ title: 'Success', message: this.$root.$t('notifications.customer.deleted'), type: 'success' })
        break
      }
    }
  }
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/customers/customer-dropdown.vue